/**
 * Production-safe Frontend Logger Utility
 * 
 * Development: Tüm log'ları gösterir
 * Production: Sadece error gösterir
 * 
 * @module utils/logger
 */

const isDevelopment = process.env.NODE_ENV !== 'production';

// Log levels
const LOG_LEVELS = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3
};

// Aktif log level (production'da sadece ERROR)
const activeLevel = isDevelopment ? LOG_LEVELS.DEBUG : LOG_LEVELS.ERROR;

/**
 * Debug log - sadece development'ta gösterilir
 */
export const debug = (message, data = null, tag = '') => {
    if (activeLevel <= LOG_LEVELS.DEBUG) {
        const prefix = tag ? `[${tag}]` : '';
        if (data) {
            console.log(prefix, message, data);
        } else {
            console.log(prefix, message);
        }
    }
};

/**
 * Info log - sadece development'ta gösterilir
 */
export const info = (message, data = null, tag = '') => {
    if (activeLevel <= LOG_LEVELS.INFO) {
        const prefix = tag ? `[${tag}]` : '';
        if (data) {
            console.log(prefix, message, data);
        } else {
            console.log(prefix, message);
        }
    }
};

/**
 * Warning log - sadece development'ta gösterilir
 */
export const warn = (message, data = null, tag = '') => {
    if (activeLevel <= LOG_LEVELS.WARN) {
        const prefix = tag ? `[${tag}]` : '';
        if (data) {
            console.warn(prefix, message, data);
        } else {
            console.warn(prefix, message);
        }
    }
};

/**
 * Error log - her zaman gösterilir
 */
export const error = (message, data = null, tag = '') => {
    const prefix = tag ? `[${tag}]` : '';
    if (data) {
        console.error(prefix, message, data);
    } else {
        console.error(prefix, message);
    }
};

/**
 * Tagged logger oluştur
 */
export const createLogger = (tag) => {
    return {
        debug: (message, data = null) => debug(message, data, tag),
        info: (message, data = null) => info(message, data, tag),
        warn: (message, data = null) => warn(message, data, tag),
        error: (message, data = null) => error(message, data, tag)
    };
};

// Default export
const logger = {
    debug,
    info,
    warn,
    error,
    createLogger,
    isDevelopment
};

export default logger;
